const addDollarSign = (value: number | string | null | undefined): string => {
  if (!value) {
    return '$0';
  }

  return `$${value}`;
};

export default addDollarSign;